import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";

// An Upfront/Capped default for one tax; Sales Tax unless told otherwise.
export const DefaultSettingsSalesTax = ({label = 'Sales Tax', field = 'is_sales_tax_capped'}) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()

    return (
        <TableRow
            key={label}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={isTabletOrMobile ? '60%' : '40%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {label}
                </div>
            </TableCell>
            {/* Empty spacer so Capped lands in the same column as the Fees Capped */}
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
            <TableCell
                className={'DealPageFee'}
                align="center"
                size={'small'}
                width={'20%'}
            >
                <Tooltip title={quoteSettings[field] ? 'Upfront' : 'Cap'} arrow placement={'top'}>
                    <Switch
                        checked={Boolean(quoteSettings[field])}
                        onChange={() => {
                            setSettingsStateWithUpdate({[field]: !quoteSettings[field]}, true)
                        }}
                    />
                </Tooltip>

            </TableCell>
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
        </TableRow>
    )
}